module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/eyeCream@3x_2124de.png";